import { asyncAction } from 'lib/actionCreators'

export const candidateProfile = asyncAction('super-manager/CANDIDATE_PROFILE')

// candidate job note
export const getCandidateJobNotes = asyncAction('super-manager/GET_CANDIDATE_JOB_NOTES')
export const addCandidateJobNote = asyncAction('super-manager/ADD_CANDIDATE_JOB_NOTE')
export const deleteCandidateJobNote = asyncAction('super-manager/DELETE_CANDIDATE_JOB_NOTE')
export const editCandidateJobNote = asyncAction('super-manager/EDIT_CANDIDATE_JOB_NOTE')
